exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".coupon-report-list .multiselect__tags{border:none!important}", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/views/admin/report/components/FilterComponent.vue"],"names":[],"mappings":"AACA,uCACI,qBAAwB,CAC3B","file":"FilterComponent.vue","sourcesContent":["\n.coupon-report-list .multiselect__tags{\n    border: none !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1a9b4c45","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=2!./src/views/admin/report/components/FilterComponent.vue
// module id = 2283
// module chunks = 0